module.exports = __webpack_public_path__ + "img/browser.6d4bbc55.svg";